/* LH | Several sock pairs on the product page (Leon, 25.10.2026, canvas "V1 im Look der Produktseite").
 * Config: snippets/lh-cross-sell-config.liquid (#lh-multi-pair-config), only on products with the sock cross-sell entry.
 *
 * Why not the TeeInBlue cross-sell: it holds exactly ONE extra item per add to cart. For many pairs each pair goes into
 * the cart on its own through TeeInBlue's normal add to cart ("In den Warenkorb", #teeAtcButton), so every pair is a
 * plain TeeInBlue line with its own _customization_id and print file, exactly like a single order today (Printlabs
 * takes it as one more item of the same shipment).
 *
 * States, so the customer always knows where they are (Leon QA 26.10.2026):
 * - "im Warenkorb": every sock pair in the cart (any design, oldest first = pair 1). Thumbnail = TeeInBlue's design
 *   image of that line, actions Vorschau, Bearbeiten, Entfernen. Works for every pair on every device, because both
 *   come from TeeInBlue by the line's _customization_id: the image from cdn.teeinblue.com/customizations/<id>.jpg,
 *   the form data from TeeInBlue's storefront API (the same call TeeInBlue's own SDK uses).
 * - "noch nicht im Warenkorb": the pair being designed in the form above, thumbnail = live preview.
 * - "+ Weiteres Sockenpaar gestalten": puts the pair being designed into the cart and starts the next one empty.
 * - "in Bearbeitung": "Bearbeiten" loads that pair into the form (TeeInBlue restores its saved form on page load,
 *   localStorage teeinblue-customizations) together with its gift box, "Änderung speichern" adds the changed pair and
 *   removes the old one with its box. The changed pair keeps its gift box and is the last pair then; block, cart and
 *   cart discount count the same order (Agent QA 28.10.2026, saveEdit below).
 * After every step a short note says what happened, and a line above the form says which pair is being designed.
 *
 * Prices (shop rule, docs/UI-RULES.md "Pricing"): formulas on the single item, never typed amounts. Struck price = the
 * single item's compare-at price. Pair 1 full price, pair 2 -pct2 %, every further pair -pct3 %, rounded to the price
 * ending of the currency. Percents come from the shop metafield custom.multi_pair, the same source as the cart discount
 * (checkout-blocks-custom extensions/sock-tier-discount), so product page and cart always match.
 *
 * Live since 26.10.2026 on every product with the sock cross-sell entry (it replaces the second pair card).
 */
(function () {
  if (window.__lhMpLoaded) return;
  window.__lhMpLoaded = true;

  var cfg = null;
  try { cfg = JSON.parse(document.getElementById('lh-multi-pair-config').textContent); } catch (e) { return; }
  var MAX = cfg.max || 5;
  var NOCUR = 'lhMpNoCur';
  var FLAG = 'lhMpAdding', EDIT = 'lhMpEdit', NOTICE = 'lhMpNotice', TEE_FORMS = 'teeinblue-customizations', GOPTS = 'teeinblue-global-options';
  var SHOP = (window.Shopify && Shopify.shop) || '';
  // A note survives exactly one reload (sessionStorage), then lives in memory until the next step replaces it.
  var notice = null;
  try { notice = JSON.parse(sessionStorage.getItem(NOTICE)); sessionStorage.removeItem(NOTICE); } catch (e) {}
  document.documentElement.classList.add('lh-mp');

  function money(cents) {
    var fmt = cfg.moneyFormat || '{{amount_with_comma_separator}}€';
    function num(n, d, t, dec) {
      var parts = (Number(n) / 100).toFixed(d).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, t);
      return parts[0] + (parts[1] ? dec + parts[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return num(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return num(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return num(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return num(cents, 2, "'", '.');
        case 'amount_with_space_separator': return num(cents, 2, ' ', ',');
        default: return num(cents, 2, ',', '.');
      }
    });
  }

  // Round to the price ending of the currency: ,95 for EUR and CHF, whole units ending in 9 for SEK, DKK and PLN.
  function roundPrice(cents) {
    if (cfg.wholeUnits) return Math.round((cents + 100) / 1000) * 1000 - 100;
    return Math.round((cents - 95) / 100) * 100 + 95;
  }
  // pairs beyond MAX pay the full price, the same as the cart discount (sock-tier-discount, QA 26.10.2026)
  function tierPrice(full, pos) {
    if (pos <= 1 || pos > MAX) return full;
    return roundPrice(full * (pos === 2 ? (100 - cfg.pct2) : (100 - cfg.pct3)) / 100);
  }

  // TeeInBlue's size radios only change ?variant= in the URL, the theme's hidden variant input keeps the old size until
  // the add to cart (QA 26.10.2026: row said "Taille S" after choosing M). So the URL comes first.
  function variantPrice() {
    var input = document.querySelector('form[data-type="add-to-cart-form"] .product-variant-id') || document.querySelector('.product-variant-id');
    var fromUrl = new URLSearchParams(location.search).get('variant') || '';
    var id = (cfg.prices[fromUrl] && fromUrl) || (input && input.value) || '';
    var p = cfg.prices[id];
    if (!p) { var keys = Object.keys(cfg.prices); p = keys.length ? cfg.prices[keys[0]] : [0, '']; }
    return p;
  }

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function readLS(k, d) { try { return JSON.parse(localStorage.getItem(k)) || d; } catch (e) { return d; } }
  function writeLS(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function readSS(k) { try { return JSON.parse(sessionStorage.getItem(k)); } catch (e) { return null; } }
  function t(key, vars) {
    return String(cfg.t[key] || '').replace(/\{(\w+)\}/g, function (_, k) { return vars && vars[k] != null ? vars[k] : ''; });
  }
  // "Zum Warenkorb · n Paare": Polish has its own plural for 2 to 4 (pary), toCartFew equals toCart elsewhere
  function toCartLabel(n) {
    if (n === 1) return t('toCartOne');
    var few = n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 12 || n % 100 > 14);
    return t(few && cfg.t.toCartFew ? 'toCartFew' : 'toCart', { n: n });
  }
  // after an add: the next pair, or at the limit that all pairs are in the cart (QA 26.10.2026: "Sockenpaar 6")
  function addedText(socks) {
    return socks >= MAX ? t('full', { m: MAX }) : t('addedNote', { n: socks, next: socks + 1 });
  }

  /* ---------- TeeInBlue data per cart line ---------- */
  // never a cached cart: iOS Safari answered /cart.js from its cache right after an add ("Sockenpaar 0", QA 26.10.2026)
  function cartUrl() { return '/cart.js?_=' + Date.now(); }
  // byTeeinblue: TeeInBlue re-runs its add-on check after every request to a /cart URL, on the cart as it is at that
  // moment. Between two steps of ours (a pair and its copy, a box before its pair) it saw a cart in between and added a
  // box again (Agent QA 28.10.2026: boxes with quantity 2 and 3). Reads and writes of this block do not start it; the
  // check runs again on the next page with the finished cart.
  var QUIET = { cache: 'no-store', headers: { accept: 'application/json' }, byTeeinblue: true };
  function getCart() { return fetch(cartUrl(), QUIET).then(function (r) { return r.json(); }); }
  function cid(it) { return it && it.properties && it.properties._customization_id; }
  // the extras of a pair: TeeInBlue addon lines (gift box) carry the pair's _customization_id as _tib_customization_id
  function extrasOf(items, id) {
    return (items || []).filter(function (i) { var p = i.properties || {}; return id && !p._customization_id && String(p._tib_customization_id || '') === String(id); });
  }
  function designImage(it) { return cid(it) ? 'https://cdn.teeinblue.com/customizations/' + cid(it) + '.jpg' : (it.image || cfg.img); }
  // TeeInBlue restores the last form of a product on page load. Clear it after every add, so the next pair starts empty.
  function clearTeeForm(productId) {
    writeLS(TEE_FORMS, readLS(TEE_FORMS, []).filter(function (x) { return String(x.productId) !== String(productId || cfg.productId); }));
  }
  // TeeInBlue remembers global options (gift box) across pairs in localStorage teeinblue-global-options. Every new pair
  // starts with "Keine" (Leon 26.10.2026), so a box is never added to the next pair unasked.
  function resetGiftBox() {
    var o = readLS(GOPTS, {});
    Object.keys(o).forEach(function (id) { if (/^box-/.test(String(o[id] && o[id].value)) && o[id].value !== 'box-none') delete o[id]; });
    writeLS(GOPTS, o);
  }
  function formHasDesign() {
    try { return /uploads\//.test(JSON.stringify(window.teeinblue.getCurrentCustomization())); } catch (e) { return false; }
  }
  function liveMockup() {
    return document.querySelector('#tee-gallery .tee-mockup-item--loaded .tee-mockup') || document.querySelector('.tee-mockup-item--loaded .tee-mockup');
  }

  var pairs = [], cartLoaded = false;
  // the designs of the first cart read on this page: while editing, the line TeeInBlue adds on save is the new one
  var baseIds = null;
  // Another design in the cart: only the design name ("Dein Foto"), the title format is "<Design> – Personalisierte Socken".
  function designName(title) { return String(title || '').split(/\s[–-]\s/)[0]; }
  function isSock(item) { return (cfg.skus || []).some(function (p) { return (item.sku || '').indexOf(p) === 0; }); }
  function sizeOf(it) { return it.variant_options && it.variant_options.length ? String(it.variant_options[it.variant_options.length - 1]).split(' ')[0] : ''; }
  function loadCart() {
    return getCart().then(function (cart) {
      pairs = [];
      cartLoaded = true;
      // oldest line first: pair 1 is the pair designed first and keeps the full price (same order as the cart discount)
      (cart.items || []).slice().reverse().forEach(function (it) {
        if (!isSock(it)) return;
        for (var q = 0; q < it.quantity; q++) pairs.push(it);
      });
      if (!baseIds) { baseIds = {}; pairs.forEach(function (p) { baseIds[cid(p)] = true; }); }
      render();
    }).catch(function () {});
  }
  function posOf(key) { for (var i = 0; i < pairs.length; i++) if (pairs[i].key === key) return i + 1; return 0; }
  function item(key) { return pairs.filter(function (p) { return p.key === key; })[0]; }

  var block = null;
  function anchor() {
    var tee = document.querySelector('.tee-cross-sell-product-button');
    var dc = document.querySelector('.ck-datacheck--injected');
    if (dc && dc.parentElement) return { el: dc, where: 'beforebegin' };
    if (tee) return { el: tee, where: 'afterend' };
    return null;
  }

  // Shop wide icons (docs/UI-RULES.md), same SVGs as lh-cross-sell-pair.js
  var PEN = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z"/></svg>';
  var BIN = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18"/><path d="M8 6V4h8v2"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6M14 11v6"/></svg>';
  var EYE = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12Z"/><circle cx="12" cy="12" r="3"/></svg>';
  var UP = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 19V5"/><path d="M5 12l7-7 7 7"/></svg>';
  var CHECK = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
  function act(cls, icon, label, attr, val) {
    var b = el('button', 'lh-mp__act ' + cls);
    b.type = 'button';
    b.setAttribute(attr, val == null ? '' : val);
    if (icon) b.innerHTML = icon;
    b.appendChild(el('span', '', label));
    return b;
  }
  function tag(cls, icon, text) {
    var s = el('span', 'lh-mp__tag ' + cls);
    if (icon) s.innerHTML = icon;
    s.appendChild(el('span', '', text));
    return s;
  }

  // Price like the tealight set picker (lh-set-picker-row.liquid): price on top, struck price and "−x %" pill below
  function priceBox(price, was) {
    var pr = el('span', 'lh-mp__pr');
    pr.appendChild(el('span', 'lh-mp__price', money(price)));
    if (was > price) {
      var w = el('span', 'lh-mp__was');
      w.appendChild(el('s', '', money(was)));
      w.appendChild(el('span', 'lh-mp__pct', t('pct', { p: Math.round((was - price) / was * 100) })));
      pr.appendChild(w);
    }
    return pr;
  }

  function thumbImg(src) {
    var i = el('img', 'lh-mp__img');
    i.src = src; i.alt = ''; i.width = 40; i.height = 40; i.loading = 'lazy';
    return i;
  }
  // thumbnail of the pair being designed: a scaled clone of TeeInBlue's live preview (same idea as lh-partner-upsell.js)
  function mirrorLive(box) {
    var src = liveMockup();
    if (!src) return;
    var c = src.cloneNode(true);
    c.querySelectorAll('[id]').forEach(function (e) { e.removeAttribute('id'); });
    var inner = el('span', 'lh-mp__snapin');
    inner.style.width = src.offsetWidth + 'px';
    inner.style.height = src.offsetHeight + 'px';
    inner.style.transform = 'scale(' + (40 / Math.max(src.offsetWidth, src.offsetHeight, 1)) + ')';
    inner.appendChild(c);
    var wrap = el('span', 'lh-mp__snap');
    wrap.appendChild(inner);
    box.replaceChildren(wrap);
  }

  // one row: { state: 'cart' | 'current' | 'editing', it, pos, size, price, was }
  function row(o) {
    var r = el('div', 'lh-mp__row lh-mp__row--' + o.state + (o.fresh ? ' lh-mp__row--fresh' : ''));
    if (o.it) r.setAttribute('data-lh-mp-key', o.it.key);
    var top = el('div', 'lh-mp__rowtop');
    var media;
    if (o.state === 'current') {
      media = el('span', 'lh-mp__media');
      media.setAttribute('data-lh-mp-live', '');
      if (liveMockup() && formHasDesign()) mirrorLive(media); else media.appendChild(thumbImg(cfg.img));
    } else {
      media = el('button', 'lh-mp__media lh-mp__media--btn');
      media.type = 'button';
      media.setAttribute('data-lh-mp-preview', o.it.key);
      media.setAttribute('aria-label', t('preview'));
      var im = thumbImg(designImage(o.it));
      im.onerror = function () { im.onerror = null; im.src = o.it.image || cfg.img; };
      media.appendChild(im);
    }
    top.appendChild(media);
    var txt = el('span', 'lh-mp__txt');
    txt.appendChild(el('span', 'lh-mp__name', t('pair', { n: o.pos })));
    var sub = o.size ? t('size', { s: o.size }) : '';
    if (o.it && o.it.product_id !== cfg.productId) sub += (sub ? ' · ' : '') + designName(o.it.product_title);
    if (sub) txt.appendChild(el('span', 'lh-mp__sub', sub));
    if (o.state === 'cart') txt.appendChild(tag('lh-mp__tag--cart', CHECK, t('inCart')));
    if (o.state === 'current') txt.appendChild(tag('lh-mp__tag--open', '', t('notInCart')));
    if (o.state === 'editing') txt.appendChild(tag('lh-mp__tag--edit', PEN, t('editing')));
    top.appendChild(txt);
    top.appendChild(priceBox(o.price, o.was));
    r.appendChild(top);

    var bar = el('div', 'lh-mp__acts');
    if (o.state === 'cart' && o.locked) {
      // another pair is being edited: no second flow on top of it
    } else if (o.state === 'cart') {
      bar.appendChild(act('lh-mp__act--view', EYE, t('preview'), 'data-lh-mp-preview', o.it.key));
      bar.appendChild(act('lh-mp__act--edit', PEN, t('edit'), 'data-lh-mp-editline', o.it.key));
      bar.appendChild(act('lh-mp__act--remove', BIN, t('remove'), 'data-lh-mp-remove', o.it.key));
    } else if (o.state === 'current') {
      bar.appendChild(act('lh-mp__act--edit', UP, t('personalize'), 'data-lh-mp-toform'));
      if (pairs.length) bar.appendChild(act('lh-mp__act--remove', BIN, t('remove'), 'data-lh-mp-dropcur'));
    } else if (o.state === 'editing') {
      bar.appendChild(act('lh-mp__act--edit', UP, t('change'), 'data-lh-mp-toform'));
      bar.appendChild(act('lh-mp__act--remove', '', t('cancel'), 'data-lh-mp-cancel'));
    }
    if (bar.childNodes.length) r.appendChild(bar);
    return r;
  }

  // The next pair is its own row and the button at once (Leon QA 25.10.2026: a separate filled button competed with
  // "In den Warenkorb"). The subline says what the tap does.
  function addRow(curPos, price, was, locked) {
    // greyed until the pair in the form has a photo; a tap still says what is missing (Leon QA 26.10.2026)
    var r = el('button', 'lh-mp__row lh-mp__row--add' + (locked ? ' lh-mp__row--locked' : ''));
    r.type = 'button';
    r.setAttribute('data-lh-mp-add', '');
    r.appendChild(el('span', 'lh-mp__plus', '+'));
    var txt = el('span', 'lh-mp__txt');
    txt.appendChild(el('span', 'lh-mp__name lh-mp__name--add', t('cta', { next: curPos + 1 })));
    r.appendChild(txt);
    r.appendChild(priceBox(price, was));
    return r;
  }

  function render() {
    var a = anchor();
    if (!a) return;
    if (!block) {
      block = el('div', 'lh-mp');
      block.setAttribute('data-lh-mp', '');
      block.id = 'lh-mp';
    }
    if (a.where === 'beforebegin' ? a.el.previousElementSibling !== block : a.el.nextElementSibling !== block) a.el.insertAdjacentElement(a.where, block);
    var vp = variantPrice();
    var full = vp[0];
    var was = Math.max(vp[2] || 0, full);
    var n = pairs.length;
    var ed = readSS(EDIT);
    // a line key changes with its discount (another pair added or removed): the edit follows the design (Codex review 28.10.2026)
    if (ed && ed.id && !item(ed.key)) {
      var same = pairs.filter(function (p) { return cid(p) === ed.id; })[0];
      if (same) { ed.key = same.key; sessionStorage.setItem(EDIT, JSON.stringify(ed)); }
    }
    // only drop an edit whose line is gone once the cart is known (render runs before /cart.js answered)
    if (ed && cartLoaded && !item(ed.key)) { sessionStorage.removeItem(EDIT); ed = null; }
    if (ed && !item(ed.key)) ed = null;
    if (ed && String(ed.product) !== String(cfg.productId)) ed = null; // edited on another design's page
    // the customer dropped the pair being designed (Leon QA 26.10.2026): no "in Gestaltung" row until they start a
    // new one (add row, or designing in the form). Without a pair in the cart there is always one.
    var noCur = sessionStorage.getItem(NOCUR) === String(cfg.productId) && n > 0 && !ed;
    if (noCur && formHasDesign()) { sessionStorage.removeItem(NOCUR); noCur = false; }
    var cur = n < MAX && !ed && !noCur ? 1 : 0;
    var hintEl = block.querySelector('.lh-mp__hint');
    block.textContent = '';

    var head = el('div', 'lh-mp__head');
    head.appendChild(el('span', 'lh-mp__title', n ? t('yours') : t('title')));
    var saved = 0;
    // savings and badge against the struck price, so they match what the customer sees. Only pairs in the cart count,
    // not the next pair in the form (Agent QA 28.10.2026: 22,00 € instead of 15,00 € with 3 pairs in the cart).
    for (var i = 0; i < n; i++) saved += was - tierPrice(full, i + 1);
    var maxPct = Math.round((was - tierPrice(full, 3)) / was * 100);
    head.appendChild(el('span', 'lh-mp__badge', n ? t('saving', { s: money(saved) }) : t('badge', { p: maxPct })));
    block.appendChild(head);

    var note = notice;
    if (note && note.text) {
      var nb = el('p', 'lh-mp__notice');
      nb.setAttribute('role', 'status');
      nb.innerHTML = CHECK;
      nb.appendChild(el('span', '', note.text));
      block.appendChild(nb);
    }
    if (ed) {
      var eb = el('div', 'lh-mp__editbar');
      eb.appendChild(el('p', '', t('editBar', { n: posOf(ed.key) })));
      var dr = readSS(DRAFT);
      if (dr) eb.appendChild(el('p', 'lh-mp__editdraft', t('draftKept', { n: dr.pos })));
      // no own save button: TeeInBlue's big button says "Änderung speichern" now (one filled button, docs/UI-RULES.md)
      block.appendChild(eb);
    }

    var list = el('div', 'lh-mp__list');
    var marked = false;
    pairs.forEach(function (it, idx) {
      var pos = idx + 1;
      // a line with quantity 2 shows twice; only its first unit is the one being edited
      var editingThis = !!ed && ed.key === it.key && !marked;
      if (editingThis) marked = true;
      list.appendChild(row({
        state: editingThis ? 'editing' : 'cart', it: it, pos: pos, size: sizeOf(it), price: tierPrice(full, pos), was: was,
        locked: !!ed && !editingThis, fresh: !!(note && note.key === it.key)
      }));
    });
    if (cur) list.appendChild(row({ state: 'current', pos: n + 1, size: vp[1], price: tierPrice(full, n + 1), was: was }));
    if (!ed && noCur && n < MAX) list.appendChild(addRow(n, tierPrice(full, n + 1), was));
    else if (!ed && n + 1 < MAX) list.appendChild(addRow(n + 1, tierPrice(full, n + 2), was, !formHasDesign()));
    // "Zum Warenkorb" sits where TeeInBlue's button is (after the print file check), the same order as on every product
    cartButton(noCur ? toCartLabel(n) : '');
    block.appendChild(list);
    if (hintEl) block.appendChild(hintEl);

    // while editing, TeeInBlue's big button saves the change: say so (CSS label, TeeInBlue's Vue keeps its own text)
    document.documentElement.classList.toggle('lh-mp-editing', !!ed || saving);
    document.documentElement.classList.toggle('lh-mp-nocur', noCur);
    document.documentElement.style.setProperty('--lh-mp-save', JSON.stringify(t(saving ? 'loading' : 'save')));
    block.appendChild(el('p', 'lh-mp__note', ed ? t('editNote') : n + cur >= MAX ? t('max', { m: MAX }) : t('note')));
    if (/lhmpdebug=1/.test(location.search) || readLS('lhMpDebug', 0)) {
      writeLS('lhMpDebug', 1);
      var dbg = el('pre', 'lh-mp__debug', (readSS('lhMpLog') || []).join('\n') || 'no save yet');
      dbg.style.cssText = 'white-space:pre-wrap;font-size:10px;line-height:1.3;background:#fff;border:1px dashed #b0479f;padding:6px;margin:8px 0 0;max-height:none';
      block.appendChild(dbg);
    }
    formNote(n, ed, noCur);
  }

  function cartButton(label) {
    var old = document.querySelector('[data-lh-mp-cartbtn]');
    var actions = document.getElementById('teeFormActions');
    if (!label || !actions) { if (old) old.remove(); return; }
    if (!old) {
      old = document.createElement('button');
      old.type = 'button';
      old.className = 'lh-mp-cartbtn';
      old.setAttribute('data-lh-mp-cartbtn', '');
    }
    old.textContent = label;
    if (old.parentElement !== actions) actions.appendChild(old);
  }

  // The grey head of the TeeInBlue form ("Produkt personalisieren") names the pair the form is for (Leon 26.10.2026,
  // canvas variant A: no extra box). Text via a CSS variable, the head is a ::before in ck-custom.css.liquid.
  function formNote(n, ed, noCur) {
    var text = ed ? t('formEdit', { n: posOf(ed.key) }) : (n && !noCur && n < MAX) ? t('formNext', { n: n + 1 }) : '';
    var root = document.documentElement;
    root.classList.toggle('lh-mp-head', !!text);
    if (text) root.style.setProperty('--lh-mp-head', JSON.stringify(text));
    var old = document.querySelector('[data-lh-mp-formnote]');
    if (old) old.remove();
  }

  function openPreview(it) {
    var ov = el('div', 'lh-mp-pv');
    ov.setAttribute('role', 'dialog');
    ov.setAttribute('aria-modal', 'true');
    var card = el('div', 'lh-mp-pv__card');
    var x = el('button', 'lh-mp-pv__x', '×');
    x.type = 'button';
    x.setAttribute('aria-label', t('close'));
    card.appendChild(x);
    var pos = posOf(it.key);
    card.appendChild(el('p', 'lh-mp-pv__t', t('pair', { n: pos }) + (sizeOf(it) ? ' · ' + t('size', { s: sizeOf(it) }) : '')));
    var img = el('img', 'lh-mp-pv__img');
    img.src = designImage(it);
    img.alt = t('pair', { n: pos });
    img.onerror = function () { img.onerror = null; img.src = it.image || cfg.img; };
    card.appendChild(img);
    var btns = el('div', 'lh-mp-pv__btns');
    if (!readSS(EDIT)) btns.appendChild(act('lh-mp__act--edit', PEN, t('edit'), 'data-lh-mp-editline', it.key));
    btns.appendChild(act('lh-mp__act--remove', '', t('close'), 'data-lh-mp-pvclose'));
    card.appendChild(btns);
    ov.appendChild(card);
    function close() { ov.remove(); document.removeEventListener('keydown', esc); }
    function esc(e) { if (e.key === 'Escape') close(); }
    ov.addEventListener('click', function (e) {
      if (e.target === ov || e.target.closest('.lh-mp-pv__x') || e.target.closest('[data-lh-mp-pvclose]')) return close();
      var edb = e.target.closest('[data-lh-mp-editline]');
      if (edb) { close(); askEdit(it); }
    });
    document.addEventListener('keydown', esc);
    document.body.appendChild(ov);
    x.focus();
  }

  /* ---------- edit ---------- */
  // "Bearbeiten" goes straight into the edit (Leon QA 26.10.2026: no warning). A pair that is half designed in the form
  // and not in the cart yet is kept as a draft and comes back into the form once the edit is saved or cancelled.
  var DRAFT = 'lhMpDraft';
  function askEdit(it) {
    if (formHasDesign() && !readSS(EDIT) && !readSS(DRAFT)) {
      var input = document.querySelector('form[data-type="add-to-cart-form"] .product-variant-id');
      try {
        sessionStorage.setItem(DRAFT, JSON.stringify({ product: cfg.productId, path: location.pathname, variant: input ? input.value : '',
          pos: pairs.length + 1, data: JSON.parse(JSON.stringify(window.teeinblue.getCurrentCustomization())), gopts: readLS(GOPTS, {}) }));
      } catch (e) {}
    }
    startEdit(it);
  }
  // after an edit: back to the draft (its page, its form) or a fresh page
  function afterEditUrl() {
    var d = readSS(DRAFT);
    sessionStorage.removeItem(DRAFT);
    if (!d || !d.data) return location.pathname;
    var list = readLS(TEE_FORMS, []).filter(function (x) { return String(x.productId) !== String(d.product); });
    list.push({ productId: String(d.product), customization: d.data, timestamp: Date.now() });
    writeLS(TEE_FORMS, list);
    if (d.gopts) writeLS(GOPTS, d.gopts); // the draft's gift box choice, the edit set the edited pair's
    return d.path + (d.variant ? '?variant=' + d.variant : '');
  }
  // The edit form shows the gift box the pair has in the cart (Agent QA 28.10.2026: it opened with "ohne
  // Geschenkverpackung" and the save dropped the box). TeeInBlue restores a global option from localStorage
  // teeinblue-global-options on page load; which option adds which box variant says the product's campaign.
  function presetGiftBox(it) {
    var campaign = 'https://api.teeinblue.com/api/merchant/campaigns/' + encodeURIComponent(it.product_id) + '.json?shop=' + encodeURIComponent(SHOP);
    return Promise.all([getCart(), fetch(campaign).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })]).then(function (res) {
      var line = (res[0].items || []).filter(function (i) { return cid(i) === cid(it); })[0] || it;
      // the box lines of the pair, and the add-ons its line asks for (_tib_addon_variant "variant:qty|..."), in case
      // TeeInBlue's check has not put a box line back yet
      var boxes = extrasOf(res[0].items, cid(it)).map(function (b) { return String(b.variant_id); });
      String((line.properties && line.properties._tib_addon_variant) || '').split('|').forEach(function (a) { var v = a.split(':')[0]; if (v) boxes.push(v); });
      var set = {}, hit = false;
      ((res[1] && res[1].global_options) || []).forEach(function (g) {
        var opts = (g && g.data && g.data.options) || [];
        var addons = function (o) { return (o && o.addons) || []; };
        if (!opts.some(function (o) { return addons(o).length; })) return; // not an add-on option
        var pick = opts.filter(function (o) { return addons(o).some(function (a) { return boxes.indexOf(String(a.id)) >= 0; }); })[0];
        var none = opts.filter(function (o) { return !addons(o).length; })[0];
        if (pick) hit = true;
        if (pick || none) set[g.id] = (pick || none).id;
      });
      if (boxes.length && !hit) throw new Error('box option'); // the form could not show the pair's box: no edit
      var o = readLS(GOPTS, {});
      Object.keys(set).forEach(function (k) { o[k] = { value: set[k], extra: {}, timestamp: Date.now() }; });
      writeLS(GOPTS, o);
    });
  }
  function startEdit(it) {
    var id = cid(it);
    if (!id) return;
    var b = block && block.querySelector('[data-lh-mp-key="' + it.key + '"] [data-lh-mp-editline]');
    if (b) { b.disabled = true; b.lastChild.textContent = t('loading'); }
    var box = presetGiftBox(it);
    fetch('https://api.teeinblue.com/api/merchant/shopify/customization/' + encodeURIComponent(id) + '?shop=' + encodeURIComponent(SHOP))
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (c) { return box.then(function () { return c; }); })
      .then(function (c) {
        if (!c || !c.data) throw new Error('no data');
        var list = readLS(TEE_FORMS, []).filter(function (x) { return String(x.productId) !== String(it.product_id); });
        list.push({ productId: String(it.product_id), customization: c.data, timestamp: Date.now() });
        writeLS(TEE_FORMS, list);
        sessionStorage.setItem(EDIT, JSON.stringify({ key: it.key, id: id, product: it.product_id, qty: it.quantity }));
        sessionStorage.setItem('lhMpScrollForm', '1');
        location.href = String(it.url || location.pathname).split('?')[0] + '?variant=' + (c.platform_variant_id || it.variant_id);
      })
      .catch(function () {
        // the edit did not start (TeeInBlue unreachable, box not known): nothing changes, the draft stays in the form
        if (!readSS(EDIT)) sessionStorage.removeItem(DRAFT);
        if (b) { b.disabled = false; b.lastChild.textContent = t('edit'); }
        hint(t('editFailed'));
      });
  }
  function stopEdit() {
    sessionStorage.removeItem(EDIT);
    clearTeeForm();
    resetGiftBox();
    location.href = afterEditUrl();
  }

  // Only an add that put a sock pair into the cart counts. The print file check (ck-datacheck.js) and other add-ons
  // add their own line first; reacting to that reloaded the page before TeeInBlue added the pair (QA 26.10.2026).
  function addsSock(body) {
    var j;
    try { j = JSON.parse(body); } catch (e) { return 'maybe'; } // not JSON: only the cart can tell
    var items = j && (j.items || (j.sku != null ? [j] : []));
    return (items || []).some(isSock);
  }

  // Any successful add to cart: the theme's product-form.js, TeeInBlue's own request to /cart/add (fetch or XHR).
  var addedHook = null;
  // "Änderung speichern" until the fresh page: TeeInBlue's button says "Wird geladen …" and the cart drawer TeeInBlue
  // opens stays hidden, it would show the cart in the middle of saveEdit (Agent QA 28.10.2026 round 2: a "Sockenpaar 4"
  // with a box for a moment). Back to normal when the save does not go through (field missing, no add within 25 s).
  var saving = false, savingT = null;
  function setSaving(on) {
    saving = on;
    clearTimeout(savingT);
    if (on) savingT = setTimeout(function () { setSaving(false); }, 25000);
    document.documentElement.classList.toggle('lh-mp-saving', on);
    document.documentElement.classList.toggle('lh-mp-editing', on || !!readSS(EDIT));
    document.documentElement.style.setProperty('--lh-mp-save', JSON.stringify(t(on ? 'loading' : 'save')));
  }
  // Several adds can belong to one pair (print file check, gift box): reload only once all of them are answered.
  var inflight = 0, lastCartAct = 0;
  function addFinished() { inflight = Math.max(0, inflight - 1); lastCartAct = Date.now(); }
  function whenCartQuiet(cb) {
    var start = Date.now();
    (function wait() {
      if ((inflight === 0 && Date.now() - lastCartAct > 900) || Date.now() - start > 12000) return cb();
      setTimeout(wait, 200);
    })();
  }
  (function hookCartAdd() {
    var isAdd = function (url) { return /\/cart\/add(\.js)?(\?|$)/.test(String(url || '')); };
    var of = window.fetch;
    if (of) window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url);
      if (isAdd(url)) { inflight++; lastCartAct = Date.now(); }
      var p = of.apply(this, arguments);
      if (isAdd(url)) p.then(addFinished, addFinished);
      if (isAdd(url)) p.then(function (r) {
        if (!r || !r.ok) return;
        r.clone().text().then(function (body) { var a = addsSock(body); if (a === true) afterAdd(); else if (a === 'maybe') afterMaybeAdd(); }).catch(function () {});
      }).catch(function () {});
      return p;
    };
    var oo = XMLHttpRequest.prototype.open, os = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, url) { this.__lhAdd = isAdd(url); return oo.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function () {
      if (this.__lhAdd) { inflight++; lastCartAct = Date.now(); this.addEventListener('loadend', addFinished); }
      if (this.__lhAdd) this.addEventListener('load', function () {
        if (this.status < 200 || this.status >= 300) return;
        var a = addsSock(this.responseText);
        if (a === true) afterAdd(); else if (a === 'maybe') afterMaybeAdd();
      });
      return os.apply(this, arguments);
    };
  })();

  function sockCount(cart) { return (cart.items || []).filter(isSock).reduce(function (s, i) { return s + i.quantity; }, 0); }
  // An add whose answer we cannot read (form post): it counts once the cart really holds one more pair.
  var maybeT = null;
  function afterMaybeAdd() {
    var before = pairs.length;
    clearTimeout(maybeT);
    var tries = 0;
    (function poll() {
      getCart().then(function (cart) {
        if (sockCount(cart) > before) return afterAdd();
        if (++tries < 12) maybeT = setTimeout(poll, 700);
      }).catch(function () {});
    })();
  }
  var addDone = 0;
  function afterAdd() {
    if (Date.now() - addDone < 1500) return; // fetch hook and cart poll can both report the same add
    addDone = Date.now();
    var ed = readSS(EDIT);
    clearTeeForm();
    resetGiftBox();
    // a pair went into the cart: the next one is "in Gestaltung" again (a dropped pair from before must not stick,
    // Leon QA 26.10.2026: "Jetzt gestaltest du Sockenpaar 2" next to "Zum Warenkorb")
    sessionStorage.removeItem(NOCUR);
    if (ed) {
      // the changed pair is in the cart: the old one goes, then a fresh page
      sessionStorage.removeItem(EDIT);
      setSaving(true);
      clearTimeout(savingT); // the add went through: hidden until the fresh page
      setTimeout(function () { location.href = location.pathname; }, 30000); // a cart request that never answers
      var oldPos = posOf(ed.key);
      whenCartQuiet(function () {
        saveEdit(ed).then(function (res) {
          // the number only when it changed (the changed pair goes to the end of the cart)
          sessionStorage.setItem(NOTICE, JSON.stringify({ text: !res.pos || res.pos === oldPos ? t('savedShort') + '.' : t('savedNote', { n: res.pos }), short: t('savedShort'), key: res.key }));
          sessionStorage.setItem('lhMpScroll', '1');
          location.href = afterEditUrl();
        });
      });
      return;
    }
    if (addedHook) return addedHook();
    // TeeInBlue's own "In den Warenkorb": the drawer opens, the list behind it updates. The form still shows the pair
    // just added; when the customer closes the drawer and stays, the page starts the next pair empty (QA 26.10.2026).
    var knownBefore = pairs.length;
    setTimeout(function () {
      loadCart();
      whenCartQuiet(function () { getCart().then(function (cart) {
        var socks = Math.max(knownBefore + 1, (cart.items || []).filter(isSock).reduce(function (s, i) { return s + i.quantity; }, 0));
        resetWhenDrawerCloses({ text: addedText(socks), short: t('addedShort', { n: socks }) });
      }); });
    }, 600);
  }

  /* "Änderung speichern": TeeInBlue added the changed pair as a new line (with its gift box, the edit form showed the
   * pair's box, presetGiftBox). The old line goes with its box in one request, so the cart never holds a box without
   * its pair (lh-partner-upsell-cart.js) or a pair without its box. The cart lists the newest line first: the changed
   * pair is the last pair now, and the block, the cart and the cart discount (sock-tier-discount) count the same line
   * order, so their tier prices always agree and the total stays the same. The note names the new number.
   * Not kept: the old number. Re-adding the later pairs behind the changed one (PR 102, rounds 3 to 6) did not give
   * the same cart every time (Agent QA: a pair moved back, a copy was gone, once a pair and a box too many).
   * Lines are found by _customization_id: a line's key changes with its discount. Resolves with the changed pair's
   * number and key. */
  // Protocol of the last save (sessionStorage lhMpLog), shown under the block with ?lhmpdebug=1
  function short(id) { return String(id || '').slice(0, 6); }
  function cartLine(cart) {
    return (cart.items || []).map(function (i) {
      var p = i.properties || {};
      return (isSock(i) ? 'P' : 'x') + short(p._customization_id || ('>' + (p._tib_customization_id || ''))) + 'q' + i.quantity;
    }).join(' ');
  }
  function mpLog(step, data) {
    try {
      var l = step === 'save' ? [] : JSON.parse(sessionStorage.getItem('lhMpLog') || '[]');
      l.push(new Date().toISOString().slice(11, 19) + ' ' + step + ' ' + (typeof data === 'string' ? data : JSON.stringify(data)));
      sessionStorage.setItem('lhMpLog', JSON.stringify(l.slice(-40)));
    } catch (e) {}
  }
  function saveEdit(ed) {
    var H = { 'Content-Type': 'application/json', accept: 'application/json', 'X-LH-Cart': '1', 'X-LH-Bag': '1' }; // ours, for the other cart hooks
    function post(url, body) {
      return fetch(url, { method: 'POST', headers: H, body: JSON.stringify(body), byTeeinblue: true }).then(function (r) { if (!r.ok) throw new Error(url.split('/').pop() + ' ' + r.status); return r.json(); });
    }
    function units(cart, id) { return (cart.items || []).reduce(function (n, i) { return n + (cid(i) === id ? i.quantity : 0); }, 0); }
    function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
    var oldId = ed.id || cid(item(ed.key)), freshId = null, want = null;
    mpLog('save', { old: oldId, base: Object.keys(baseIds || {}) });
    // one try: read the cart, take one unit of the old pair with its box. A failed request (NL round 7: 422) is tried
    // again on a fresh cart, which also says whether the unit is gone already.
    function attempt(n) {
      return getCart().then(function (cart) {
        mpLog('cart', cartLine(cart));
        var fresh = (cart.items || []).filter(function (i) { return isSock(i) && cid(i) && !(baseIds || {})[cid(i)]; })[0];
        if (fresh) freshId = cid(fresh);
        var have = units(cart, oldId);
        // the units the old pair keeps: one less than at the edit start, or than now when TeeInBlue added to it
        if (want === null) want = fresh ? (ed.qty || 1) - 1 : (have > (ed.qty || 1) ? have - 1 : have);
        if (have <= want) { if (!fresh && n === 0) mpLog('keep', 'no new line'); return; }
        var lines = (cart.items || []).filter(function (i) { return cid(i) === oldId; });
        var updates = {};
        updates[lines[0].key] = lines[0].quantity - 1;
        extrasOf(cart.items, oldId).forEach(function (bx) { updates[bx.key] = Math.min(bx.quantity, have - 1); }); // the box goes with its pair
        return post('/cart/update.js', { updates: updates })
          .catch(function (e) {
            mpLog('fail', String(e && e.message || e));
            if (n >= 2) throw e;
            return wait(800).then(function () { return attempt(n + 1); });
          });
      });
    }
    // The changed pair gets exactly the add-ons its line asks for (_tib_addon_variant "variant:qty|..."), the rule
    // TeeInBlue checks too, now and not on a later page: TeeInBlue did not always add the box of the changed pair
    // (NL rounds 7 and 10), and the drawer showed the pair without its box until /cart.
    function ensureAddons(n) {
      return getCart().then(function (cart) {
        var line = freshId && (cart.items || []).filter(function (i) { return cid(i) === freshId; })[0];
        if (!line) return;
        var qty = units(cart, freshId), todo = [];
        String((line.properties || {})._tib_addon_variant || '').split('|').forEach(function (a) {
          var v = Number(a.split(':')[0]), per = Number(a.split(':')[1]) || 1;
          if (!v) return;
          var have = extrasOf(cart.items, freshId).filter(function (b) { return Number(b.variant_id) === v; });
          var got = have.reduce(function (s2, b) { return s2 + b.quantity; }, 0);
          if (got === per * qty) return;
          mpLog('addon', v + ' ' + got + '>' + per * qty);
          if (!have.length) todo.push(function () { return post('/cart/add.js', { items: [{ id: v, quantity: per * qty, properties: { _tib_customization_id: freshId } }] }); });
          else todo.push(function () { var u = {}; u[have[0].key] = have[0].quantity + per * qty - got; return post('/cart/update.js', { updates: u }); });
        });
        return todo.reduce(function (c, f) { return c.then(f); }, Promise.resolve());
      }).catch(function (e) {
        mpLog('fail', 'addon ' + String(e && e.message || e));
        if (n < 2) return wait(800).then(function () { return ensureAddons(n + 1); });
      });
    }
    return attempt(0).catch(function (e) { mpLog('fail', 'gave up ' + String(e && e.message || e)); })
      .then(function () { return ensureAddons(0); })
      .then(getCart).then(function (cart) {
        mpLog('end', cartLine(cart));
        var list = [];
        (cart.items || []).slice().reverse().forEach(function (i) { if (isSock(i)) for (var q = 0; q < i.quantity; q++) list.push(i); });
        for (var u = 0; u < list.length; u++) if (freshId && cid(list[u]) === freshId) return { pos: u + 1, key: list[u].key };
        return { pos: 0, key: null };
      }).catch(function () { return { pos: 0, key: null }; });
  }

  function resetWhenDrawerCloses(notice) {
    var d = document.querySelector('cart-drawer');
    if (!d) return;
    var mo = new MutationObserver(function () {
      if (d.classList.contains('active')) return;
      mo.disconnect();
      sessionStorage.setItem(NOTICE, JSON.stringify(notice));
      sessionStorage.setItem('lhMpScrollForm', '1');
      location.reload();
    });
    mo.observe(d, { attributes: true, attributeFilter: ['class'] });
  }

  function waitAdded() {
    // The pair is in the cart. A fresh page = an empty TeeInBlue form for the next pair. Nothing within 25 s: reset.
    var done = false;
    var knownBefore = pairs.length;
    addedHook = function () {
      if (done) return;
      done = true;
      addedHook = null;
      whenCartQuiet(function () { getCart().then(function (cart) {
        var socks = Math.max(knownBefore + 1, (cart.items || []).filter(isSock).reduce(function (s, i) { return s + i.quantity; }, 0));
        var fresh = (cart.items || []).filter(isSock)[0];
        sessionStorage.setItem(NOTICE, JSON.stringify({ text: addedText(socks), short: t('addedShort', { n: socks }), key: fresh && fresh.key }));
      }).catch(function () {}).then(function () {
        sessionStorage.setItem('lhMpScrollForm', '1');
        location.reload();
      }); });
    };
    function cancel() {
      if (done) return;
      done = true;
      addedHook = null;
      sessionStorage.removeItem(FLAG);
      document.documentElement.classList.remove('lh-mp-adding');
      busyAdd(false);
    }
    setTimeout(cancel, 25000);
    return cancel;
  }

  // TeeInBlue refuses the add while a required field is empty. Its message sits far above: say which field and jump there.
  function missingFields() {
    return Array.prototype.filter.call(document.querySelectorAll('.tee-required-message'), function (m) {
      return m.offsetParent !== null && (m.textContent || '').trim();
    });
  }
  function missingText(miss) {
    var names = miss.map(function (m) {
      var h = m.closest('.tee-field') && m.closest('.tee-field').querySelector('.tee-field__heading');
      return h ? (h.firstChild && h.firstChild.textContent || h.textContent).replace(/\*.*$/, '').trim() : '';
    }).filter(Boolean);
    var n = pairs.length + 1;
    if (!names.length) return t('missing', { f: t('missingDefault'), n: n });
    // field names are TeeInBlue headings ("Wähle eine Hintergrundfarbe"): quoted they read as names in the sentence
    names = names.map(function (x) { return cfg.t.quote ? t('quote', { f: x }) : x; });
    var f = names.length > 1 ? names.slice(0, -1).join(', ') + ' ' + t('and') + ' ' + names[names.length - 1] : names[0];
    return t(names.length > 1 ? 'missingMany' : 'missing', { f: f, n: n });
  }
  // smooth after a tap (Leon 26.10.2026), instant right after a page load
  function scrollToY(node, offset, smooth) {
    // window.scrollTo instead of scrollIntoView: the sticky product column on desktop made scrollIntoView stop short
    var top = Math.max(0, node.getBoundingClientRect().top + window.scrollY - (offset || 140));
    window.scrollTo({ top: top, behavior: smooth ? 'smooth' : 'auto' });
    // a browser that does not animate (reduced motion, background tab) still ends at the form
    if (smooth) setTimeout(function () { if (Math.abs(window.scrollY - top) > 40) window.scrollTo({ top: top, behavior: 'auto' }); }, 1200);
  }
  function checkMissing(cancel) {
    setTimeout(function () {
      var miss = missingFields();
      if (!miss.length) return;
      if (cancel) cancel();
      if (saving) setSaving(false);
      hint(missingText(miss));
      scrollToY(miss[0].closest('.tee-field__heading') || miss[0], 140, true);
    }, 400);
  }
  function busyAdd(on) {
    var b = block && block.querySelector('[data-lh-mp-add]');
    if (!b) return;
    b.disabled = on;
    b.classList.toggle('lh-mp__row--busy', on);
    var name = b.querySelector('.lh-mp__name--add');
    if (name) name.textContent = on ? t('adding') : t('cta', { next: pairs.length + 2 });
  }
  function hint(text) {
    if (!block) return;
    var h = block.querySelector('.lh-mp__hint');
    if (!text) { if (h) h.remove(); return; }
    if (!h) { h = el('p', 'lh-mp__hint'); h.setAttribute('role', 'alert'); block.insertBefore(h, block.querySelector('.lh-mp__note')); }
    h.textContent = text;
  }
  function toForm(smooth) {
    var f = document.querySelector('.tee-customize-main-form') || document.querySelector('.tee-customization-form');
    if (f) scrollToY(f, 100, smooth);
  }

  // TeeInBlue's own big button ("In den Warenkorb", while editing "Änderung speichern") refuses silently when a field
  // is missing: say which one in the block as well
  document.addEventListener('click', function (ev) {
    if (!ev.target.closest || !ev.target.closest('#teeAtcButton') || sessionStorage.getItem(FLAG)) return;
    if (saving) { ev.preventDefault(); ev.stopImmediatePropagation(); return; } // one save at a time
    if (readSS(EDIT)) setSaving(true);
    hint('');
    checkMissing(null);
  }, true);

  document.addEventListener('click', function (ev) {
    var inBlock = block && block.contains(ev.target);
    var inNote = ev.target.closest && (ev.target.closest('[data-lh-mp-formnote]') || ev.target.closest('[data-lh-mp-cartbtn]'));
    if (!inBlock && !inNote) return;
    var b;
    if (ev.target.closest('[data-lh-mp-cancel]')) { ev.preventDefault(); return stopEdit(); }
    if (ev.target.closest('[data-lh-mp-cartbtn]')) {
      ev.preventDefault();
      var dr = document.querySelector('cart-drawer');
      if (dr && typeof dr.open === 'function') dr.open(); else location.href = '/cart';
      return;
    }
    if (!inBlock) return;
    if ((b = ev.target.closest('[data-lh-mp-preview]'))) { ev.preventDefault(); var pit = item(b.getAttribute('data-lh-mp-preview')); if (pit) openPreview(pit); return; }
    if ((b = ev.target.closest('[data-lh-mp-editline]'))) { ev.preventDefault(); var eit = item(b.getAttribute('data-lh-mp-editline')); if (eit) askEdit(eit); return; }
    if (ev.target.closest('[data-lh-mp-toform]')) { ev.preventDefault(); toForm(true); return; }
    if (ev.target.closest('[data-lh-mp-dropcur]')) {
      ev.preventDefault();
      clearTeeForm();
      resetGiftBox();
      sessionStorage.setItem(NOCUR, String(cfg.productId));
      sessionStorage.setItem(NOTICE, JSON.stringify({ text: t('droppedNote', { n: pairs.length + 1 }) }));
      sessionStorage.setItem('lhMpScroll', '1');
      location.href = location.pathname;
      return;
    }
    if (ev.target.closest('[data-lh-mp-tocart]') || ev.target.closest('[data-lh-mp-cartbtn]')) {
      ev.preventDefault();
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') drawer.open(); else location.href = '/cart';
      return;
    }
    if (ev.target.closest('[data-lh-mp-save]')) {
      ev.preventDefault();
      var satc = document.getElementById('teeAtcButton');
      if (!satc) return;
      hint('');
      satc.click();
      checkMissing(null);
      return;
    }
    if ((b = ev.target.closest('[data-lh-mp-add]'))) {
      ev.preventDefault();
      if (document.documentElement.classList.contains('lh-mp-nocur')) {
        sessionStorage.removeItem(NOCUR);
        notice = null;
        render();
        toForm(true);
        return;
      }
      var atc = document.getElementById('teeAtcButton');
      if (!atc || b.disabled) return;
      hint('');
      sessionStorage.setItem(FLAG, '1');
      document.documentElement.classList.add('lh-mp-adding');
      busyAdd(true);
      var cancel = waitAdded();
      atc.click();
      checkMissing(cancel);
      return;
    }
    if ((b = ev.target.closest('[data-lh-mp-remove]'))) {
      ev.preventDefault();
      var rit = item(b.getAttribute('data-lh-mp-remove'));
      if (!rit) return;
      var rpos = posOf(rit.key);
      b.disabled = true;
      removePair(rit).then(function (left) {
        // no note about prices moving up: the list shows the new prices (Leon QA 26.10.2026); none when no pair is left
        notice = left ? { text: t('removedNote', { n: rpos }) } : null;
        noneGiftBox();
        return loadCart();
      }).then(function () {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'lh-multi-pair' });
        // header cart count (Dawn renders it as a section)
        fetch(location.pathname + '?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (sec) {
          var box = document.getElementById('cart-icon-bubble');
          if (!box || !sec['cart-icon-bubble']) return;
          var doc = new DOMParser().parseFromString(sec['cart-icon-bubble'], 'text/html');
          var src = doc.querySelector('.shopify-section') || doc.body;
          box.innerHTML = src.innerHTML;
        }).catch(function () {});
      });
    }
  });

  // One pair out of the cart, together with its extras (gift box: _tib_customization_id = the pair's id). The print
  // file check goes too when nothing but it would be left. Resolves with the number of sock pairs left.
  function removePair(it) {
    return getCart().then(function (cart) {
      var updates = {};
      // by key, else by design: a line's key changes with its discount
      var line = (cart.items || []).filter(function (i) { return i.key === it.key; })[0] ||
        (cart.items || []).filter(function (i) { return cid(it) && cid(i) === cid(it); })[0];
      if (!line) return sockCount(cart);
      updates[line.key] = Math.max(0, line.quantity - 1);
      // The extras follow the units of the design that stay. Shopify shows a design with 2 units as one line per
      // discount (quantity 1 each), so counting only this line took both gift boxes (PR 102 follow-up, 29.10.2026).
      var left = (cart.items || []).reduce(function (n, i) { return n + (cid(i) === cid(line) ? i.quantity : 0); }, 0) - 1;
      var per = {};
      String((line.properties && line.properties._tib_addon_variant) || '').split('|').forEach(function (a) {
        var v = a.split(':')[0];
        if (v) per[v] = Number(a.split(':')[1]) || 1;
      });
      (cart.items || []).forEach(function (i) {
        if (i.properties && i.properties._tib_customization_id && i.properties._tib_customization_id === cid(line)) {
          updates[i.key] = left > 0 ? Math.min(i.quantity, left * (per[String(i.variant_id)] || 1)) : 0;
        }
      });
      var rest = (cart.items || []).filter(function (i) { return !(i.key in updates) || updates[i.key] > 0; });
      if (rest.length && rest.every(function (i) { return i.sku === 'print-file-check'; })) {
        rest.forEach(function (i) { updates[i.key] = 0; });
        ['ck_datacheck_in_cart', 'ck_datacheck_variant_id', 'ck_datacheck_main_variant'].forEach(function (k) { try { localStorage.removeItem(k); } catch (e) {} });
      }
      return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', accept: 'application/json' }, body: JSON.stringify({ updates: updates }) })
        .then(function (r) { return r.json(); }).then(function (c2) { return sockCount(c2); });
    });
  }
  // the gift box of the pair in the form back to "Keine" (TeeInBlue's none tile, styled by ck-teeinblue)
  function noneGiftBox() {
    resetGiftBox();
    document.querySelectorAll('.tee-customization-form .tee-field').forEach(function (f) {
      var h = f.querySelector('.tee-field__heading');
      if (!h || !/geschenk|verpackung|box/i.test(h.textContent)) return;
      var none = f.querySelector('.ck-none-tile');
      if (none && !none.classList.contains('active')) (none.closest('label') || none).click();
    });
  }

  var renderT = null;
  function renderSoon() { clearTimeout(renderT); renderT = setTimeout(render, 80); }
  document.addEventListener('change', renderSoon);
  // a size change reaches the page only as ?variant= in the URL (TeeInBlue uses history.replaceState)
  ['pushState', 'replaceState'].forEach(function (m) {
    var orig = history[m];
    if (typeof orig !== 'function') return;
    history[m] = function () { var r = orig.apply(this, arguments); renderSoon(); return r; };
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) { if (ev && ev.source === 'lh-multi-pair') return; if (!sessionStorage.getItem(FLAG)) loadCart(); });
  }

  function start() {
    sessionStorage.removeItem(FLAG);
    loadCart().then(function () {
      if (sessionStorage.getItem('lhMpScrollForm')) {
        sessionStorage.removeItem('lhMpScrollForm');
        setTimeout(toForm, 400);
      } else if (sessionStorage.getItem('lhMpScroll')) {
        sessionStorage.removeItem('lhMpScroll');
        if (block) setTimeout(function () { scrollToY(block, 80); }, 400);
      }
    });
    var busy = false;
    new MutationObserver(function () {
      if (busy || !block || block.isConnected) return;
      busy = true;
      setTimeout(function () { busy = false; render(); }, 60);
    }).observe(document.body, { childList: true, subtree: true });
    // the live thumbnail of the pair being designed follows TeeInBlue's preview
    var lt = null;
    new MutationObserver(function (muts) {
      if (!block || lt) return;
      if (!muts.some(function (m) { return m.target.closest && !block.contains(m.target) && m.target.closest('.tee-mockup-artwork__wrapper, .tee-mockup'); })) return;
      lt = setTimeout(function () {
        lt = null;
        var box = block && block.querySelector('[data-lh-mp-live]');
        if (box && formHasDesign()) mirrorLive(box);
        var add = block && block.querySelector('[data-lh-mp-add]');
        if (add && !document.documentElement.classList.contains('lh-mp-nocur')) add.classList.toggle('lh-mp__row--locked', !formHasDesign());
      }, 250);
    }).observe(document.body, { childList: true, subtree: true, attributes: true });
    // TeeInBlue renders its form late: try to place the block a few times
    var tries = 0;
    (function place() { if (!block || !block.isConnected) render(); if (++tries < 20 && (!block || !block.isConnected)) setTimeout(place, 300); })();
  }
  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
